import { IKeyValuePair } from '../../shared/models/common.model';
import { UploadIpexAdditionalInfo } from '../../shared/models/domain/UploadIpexAdditionalInfo';
import { ServiceModel } from './service-list.model';
import { AutoClearing, QualityCheckInfo, ServiceRejection } from './insurance-case.model';

export class BasicInformationModel {
    EmailConversationId: string;
    PrimaryEmailConversation: EmailConversationInfo;
    EmailConversationInfos: EmailConversationInfo[];
    CleimNumberInsurance: string;
    InsuranceOfficerName: string;
    InsuranceOfficerEmail: string;
    OrderDate: Date;
    IssuerZipCode: string;
    PolicyHolderName: string;
    IssuerCompanyName: string;
    IssuerEmailAddress: string;
    IssuerPhoneNumber: string;
    CaseType: string;
    Remarks: string;
    ServiceList: ServiceModel[];
    ServiceName: string;
    Unit: number;
    Quantities: number;
    UnitPrice: number;
    TotalPrice: number;
    Vat: number;
    OfferNumber: string;
    Trade: string;
    Component: string;
    AssignedBackOffice: string;
    AssignedBackOfficeSearchText: string;
    AssignedInspector: string;
    AssignedInspectorSearchText: string;
    InvoiceType: string;
    InsuranceComapnayName: string;
    CaseReferenceInfo: CaseReferenceInfo;
    InsuranceComapnayId: string;
    DepartmentId: string;
    DepartmentName: string;
    CaseStatus: IKeyValuePair;
    BackofficeUserId: string;
    BackOfficeUserName: string;
    BackOfficeProfileImageId: string;
    InspectorUserId: string;
    InspectorUserName: string;
    InspectorProfileImageId: string;
    IsVotingDone: boolean;
    CaseReportNumber: string;
    UpdatedOfferNumber: string;
    IsSelectedForQualityCheck: boolean;
    IsQualityCheckDone: boolean;
    LiabilityAssesmentAdditinalComment: string;
    EmailRecivedDate: Date;
    DocumentProcessingStatus: string;
    SLAType: string;
    ObjectStreet: string;
    ObjectStreetNumber: string;
    ObjectCity: string;
    IsNegativeTotalSavedCost: boolean;
    SiteId: string;
    UploadIpexAdditionalInfo: UploadIpexAdditionalInfo;
    CaseCreationStatus: string;
    AutoCheckStatus: IKeyValuePair;
    HasUnsuccessfulConsultation: boolean;
    HasCallBackRequest: boolean;
    ClaimDate: Date | null;
    ReadyForBillingDate: Date | null;
    ClosedDate: Date | null;
    InsuranceOfficerPhoneNumber: string;
    RejectionDate: Date | null;
    IsFlag: boolean;
    QualityCheckInfo: QualityCheckInfo;
    ServiceRejectionInfo: ServiceRejection;
    AutoClearing: AutoClearing;
}

export class CaseReferenceInfo {
    InsuranceComapnayId: string;
    InsuranceComapnayName: string;
    DepartmentId: string;
    DepartmentName: string;
}
export class EmailConversationInfo {
    ItemId: string;
    Subject: string;
    SenderName: string;
}
export class JarowaWorkorderInfo {
    WorkorderId: string;
    WorkorderStatus: string;
    DepartmentAssociateId: string;
    CaseClaimNumber: string;
    DepartmentName: string;
}
